export { Slider } from 'components/slider/SliderProps'
export type { SliderProps } from 'components/slider/SliderProps'
